/**
 * Shop with Confidence - Tooltip Management
 * Ensures only one tooltip is open at a time (hover only, no click persistence)
 */

// Guard against multiple script loads
if (typeof window.ShopWithConfidenceTooltips === 'undefined') {
  window.ShopWithConfidenceTooltips = class {
    constructor() {
      this.init();
    }

    init() {
      // Find all shop-with-confidence components
      const components = document.querySelectorAll('.swc');

      components.forEach(component => {
        // Skip if already initialized
        if (component.dataset.swcInitialized) return;
        component.dataset.swcInitialized = 'true';
        this.setupTooltips(component);
      });
    }

    setupTooltips(component) {
      const items = component.querySelectorAll('.swc__item--has-tooltip');

      items.forEach(item => {
        // Handle mouse enter - close others and show this one
        item.addEventListener('mouseenter', () => {
          this.closeAllTooltips(component);
          item.classList.add('swc__item--active');
        });

        // Handle mouse leave - hide tooltip immediately
        item.addEventListener('mouseleave', () => {
          item.classList.remove('swc__item--active');
        });

        // Prevent click from doing anything (no persistence)
        item.addEventListener('click', (e) => {
          // Don't let clicks trigger any default behavior
          // Tooltip should only show on hover
          e.preventDefault();
        });

        // Handle focus for keyboard navigation
        item.addEventListener('focus', () => {
          this.closeAllTooltips(component);
          item.classList.add('swc__item--active');
        });

        // Handle blur - remove on tab away
        item.addEventListener('blur', () => {
          item.classList.remove('swc__item--active');
        });

        // Handle keyboard navigation (Escape key)
        item.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            item.classList.remove('swc__item--active');
            item.blur();
          }
        });
      });
    }

    closeAllTooltips(component) {
      const activeItems = component.querySelectorAll('.swc__item--active');
      activeItems.forEach(item => {
        item.classList.remove('swc__item--active');
      });
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new window.ShopWithConfidenceTooltips();
    });
  } else {
    new window.ShopWithConfidenceTooltips();
  }

  // Reinitialize when sections are loaded dynamically (Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      new window.ShopWithConfidenceTooltips();
    });
  }
}
